import { Component, OnInit, Input } from '@angular/core';
import { UserService } from '@tytapp/user';
import { BaseComponent } from 'common';
import { AppConfig } from './../../common/app-config';
import { environment } from '@tytapp/environment';
import { ApiAbbreviatedArticle, ApiUser } from '@tytapp/api';

@Component({
    selector: 'tyt-article-view',
    templateUrl: './article-view.component.html',
    styleUrls: ['./article-view.component.scss']
})
export class ArticleViewComponent extends BaseComponent implements OnInit {

    constructor(
        private appConfig: AppConfig,
        private userService: UserService,
    ) {
        super();
    }

    @Input()
    user: ApiUser;

    @Input()
    public article: ApiAbbreviatedArticle;

    @Input()
    public limit = null;

    @Input()
    public showImage = true;

    @Input()
    public showFranchise = true;

    @Input()
    public showFranchiseInByLine = false;

    @Input()
    public homePageStyling: boolean = false;

    audienceType: string = 'visitor';

    get date() {
        if (!this.article || !this.article.publish_date)
            return null;

        let date = new Date(this.article.publish_date);
        if (Number.isNaN(Number(date)))
            return undefined;

        return date;
    }

    get items() {
        let items = [];

        if (this.limit > 0) {
            items = items.slice(0, this.limit);
        }
        return items;
    }

    init() {
        this.subscribe(this.userService.userChanged, (user) => {
            this.user = user;
        });
        this.audienceType = this.userService.audienceType;
    }

    get joinUrl() {
        return environment.urls.purchase;
    }

    get haveAccess() {
        return (this.user && this.user.premium) || !this.article.members_only;
    }

}
